import { Model } from '@vuex-orm/core';

export default class Ort extends Model {
  static entity = 'ort';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.id;
    /** @type {string} */
    this.name;
    /** @type {string} */
    this.bezirk;
    /** @type {string} */
    this.region;
  }

  static fields() {
    return {
      id: this.string(''),
      name: this.string(''),
      bezirk: this.string(''),
      region: this.string('')
    };
  }
}
